module.exports = __webpack_public_path__ + "img/21_63.8cf80005.png";